import { LessonBigIdeasFragment_bigIdeas } from 'approot/lesson/sections/big-ideas/__generated__/LessonBigIdeasFragment';
import { LessonTextualConceptsFragment_textualConcepts } from 'approot/lesson/sections/textual-concepts/__generated__/LessonTextualConceptsFragment';
import * as Styled from './concepts-list.style';

const ConceptsList = ({
  concepts,
}: {
  concepts:
    | LessonTextualConceptsFragment_textualConcepts[]
    | LessonBigIdeasFragment_bigIdeas[];
}) => (
  <Styled.ConceptsList>
    {concepts.map(concept => (
      <li key={concept.id}>{concept.description}</li>
    ))}
  </Styled.ConceptsList>
);

export default ConceptsList;
